import { render } from "./BookingProfit.vue?vue&type=template&id=83ba0f20&scoped=true"
import script from "./BookingProfit.vue?vue&type=script&lang=js"
export * from "./BookingProfit.vue?vue&type=script&lang=js"

import "./BookingProfit.vue?vue&type=style&index=0&id=83ba0f20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ba0f20"]])

export default __exports__